import { api, auth } from 'common/firebase';
import jwt from 'jsonwebtoken';
import axios from 'axios';
const signIn = async (username, password) => {
  let payload = {};
  try {
    const res = await axios.post(`${api}/auth/signIn`, {
      username,
      password
    });
    const { customToken } = res.data.response;
    await auth.signInWithCustomToken(customToken);
    payload = res.data.response;
  } catch (err) {
    const { status, data } = err.response;
    switch (status) {
      case 401:
        return {
          error:
            data.error === 'Incorrect password'
              ? 'รหัสผ่านไม่ถูกต้อง'
              : 'ไม่พบบัญชีนี้ในระบบ'
        };
      default:
        return { error: 'เกิดข้อผิดพลาดบางอย่าง' };
    }
  }
  return payload;
};

const submit = async (password, email, token) => {
  try {
    const res = await axios.post(
      `${api}/auth/submit`,
      {
        password,
        email: email.toLowerCase()
      },
      {
        headers: {
          Authorization: token
        }
      }
    );
    return res.data.response;
  } catch (err) {
    switch (err.response.status) {
      case 409:
        return { error: 'อีเมลถูกใช้แล้ว' };
      default:
        return { error: 'เกิดข้อผิดพลาดบางอย่าง' };
    }
  }
};
const getProfile = async () => {
  try {
    const res = await axios.get(`${api}/profile`, {
      headers: {
        Authorization: await auth.currentUser.getIdToken()
      }
    });
    return res.data.response;
  } catch (err) {
    return err.response.data;
  }
};
const resetPassword = async email => {
  try {
    const res = await axios.post(`${api}/auth/forget`, {
      email: email.toLowerCase()
    });
    return res.data;
  } catch (err) {
    switch (err.response.status) {
      case 404:
        return { error: 'ไม่พบอีเมลนี้ในระบบ' };
      default:
        return { error: 'เกิดข้อผิดพลาดบางอย่าง' };
    }
  }
};
const extractJwt = token => {
  try {
    return jwt.verify(token, 'ProGaming');
  } catch (err) {
    console.error(err);
    return { error: err.message };
  }
};
const setNewPassword = async (token, password) => {
  try {
    const verifyRes = extractJwt(token);
    if (verifyRes.error) {
      return { error: 'Invalid Token' };
    } else {
      const res = await axios.post(
        `${api}/auth/password`,
        {
          password
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      return res.data.response;
    }
  } catch (err) {
    return err.response.data;
  }
};

export { getProfile, resetPassword, setNewPassword, signIn, submit };
